import React from "react";
import "./t4-product-detail.scss";
import T4BasketAddBtnComponent from "./T4BasketAddBtnComponent";
import T4OrderAddBtnComponent from "./T4OrderAddBtnComponent";
import { MenuProductAmountType } from "../../../../../models/menu_product_amount_type";
import { GetMenuProductListResponseModel } from "../../../../../services/menu_products/models/get_menu_product_list.response";

type T4ProductDetailProps = {
  product: GetMenuProductListResponseModel;
  tableId: string;
  menuProductAmountList: MenuProductAmountType[];
  removeMenuProductAmount: (menuProductId: string) => void;
};

const nutritionItems = (product: GetMenuProductListResponseModel) => [
  {
    key: "calorie",
    show: product.calorie != null && product.calorie > 0,
    icon: "🔥",
    label: "Kalori",
    value: product.calorie,
    color: "#FF6B35",
    unit: "kcal",
  },
  {
    key: "fat",
    show: product.fat != null && product.fat > 0,
    icon: "🫙",
    label: "Yağ",
    value: product.fat,
    color: "#FFB800",
    unit: "g",
  },
  {
    key: "protein",
    show: product.protein != null && product.protein > 0,
    icon: "💪",
    label: "Protein",
    value: product.protein,
    color: "#4CAF8A",
    unit: "g",
  },
  {
    key: "carbohydrate",
    show: product.carbohydrate != null && product.carbohydrate > 0,
    icon: "🌾",
    label: "Karbonhidrat",
    value: product.carbohydrate,
    color: "#5B8CF7",
    unit: "g",
  },
  {
    key: "time",
    show: product.timeToGetReady != null && product.timeToGetReady.length > 0,
    icon: "⏱️",
    label: "Hazırlanma",
    value: product.timeToGetReady,
    color: "#A78BFA",
    unit: "dk",
  },
];

const T4ProductDetail: React.FC<T4ProductDetailProps> = ({
  product,
  tableId,
  menuProductAmountList,
  removeMenuProductAmount,
}) => {
  const visibleNutrition = nutritionItems(product).filter((n) => n.show);
  const hasAllergens =
    product.allergenicInformations != null &&
    product.allergenicInformations.length > 0;

  return (
    <div className="t4-detail-contain">
      {/* Ürün görseli ve açıklama */}
      <div className="t4-detail-content">
        <div className="pcard__img_detail">
          <img alt="" src={(product.photo ?? "").toApiImage("product.png")} />
          <div className="pcard__price-badge">
            {new Intl.NumberFormat("tr-TR", {
              style: "currency",
              currency: "TRY", // Eğer dinamikse company?.currency?.code kullanabilirsin
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }).format(product.price)}
          </div>
        </div>

        <p style={{ fontSize: "14px", fontWeight: "bold" }}>{product.detail}</p>
      </div>

      {/* Besin Değerleri */}
      {visibleNutrition.length > 0 && (
        <div className="t4-nutrition-grid">
          {visibleNutrition.map((item) => (
            <div
              key={item.key}
              className="t4-nutrition-card"
              style={{ borderTop: `3px solid ${item.color}` }}
            >
              <span className="t4-nutrition-icon">{item.icon}</span>
              <span className="t4-nutrition-label">{item.label}</span>
              <span className="t4-nutrition-value">
                {item.value} {item.unit}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Alerjen Bilgisi */}
      {hasAllergens && (
        <div className="t4-allergen-section">
          <div className="t4-allergen-header">
            <div className="t4-allergen-header-icon">⚠️</div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span className="t4-allergen-title mt-2">Alerjen Uyarısı</span>
              <span
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  marginBottom: 10,
                }}
              >
                Seçilen ürün aşağıdaki alerjenleri içermektedir.
              </span>
            </div>
          </div>

          <div className="t4-allergen-tags">
            {product.allergenicInformations!.map((allergen) => (
              <div key={allergen} className="t4-allergen-tag">
                <span className="t4-allergen-dot" />
                {allergen}
              </div>
            ))}
          </div>
        </div>
      )}
      {((product.calorie ?? 0) > 0 ||
        hasAllergens ||
        (product.carbohydrate ?? 0) > 0 ||
        (product.fat ?? 0) > 0 ||
        (product.protein ?? 0) > 0) && (
        <p
          style={{
            fontSize: "10px",
            fontWeight: "600",
            width: "100%",
            textAlign: "center",
          }}
        >
          Kalori ve besin değerleri yapay zekâ tarafından hesaplanmıştır;
          porsiyon boyutuna göre küçük farklılıklar gösterebilir
        </p>
      )}

      {/* Sepet & Sipariş Butonları */}
      <div className="t4-detail-foot">
        <T4BasketAddBtnComponent
          menuProduct={product}
          menuProductAmountList={menuProductAmountList}
          removeMenuProductAmount={removeMenuProductAmount}
          tableId={tableId}
        />
        <T4OrderAddBtnComponent
          menuProduct={product}
          removeMenuProductAmount={removeMenuProductAmount}
          menuProductAmountList={menuProductAmountList}
          tableId={tableId}
        />
      </div>
    </div>
  );
};

export default T4ProductDetail;
